import React from "react";
import PropTypes from "prop-types";

import styles from "./FixedErrorBox.module.css";

const FixedErrorBox = ({ visible = false, onClick, header, description }) => {
  return (
    <div
      className={`${styles.fixedErrorBox} ${visible ? styles.visible : ""}`}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={visible ? "-1" : "0"}
      aria-hidden={visible ? "false" : "true"}
    >
      <div className={styles.message}>
        <div className={styles.header}>{header}</div>
        <div className={styles.description}>{description}</div>
      </div>
      <div className={styles.retryButton}>RETRY</div>
    </div>
  );
};

export default FixedErrorBox;

FixedErrorBox.propTypes = {
  visible: PropTypes.bool,
  onClick: PropTypes.func,
  header: PropTypes.string,
  description: PropTypes.string,
};
